(function($) {


    // Complete order
    function register(e){

        e.preventDefault()

        let $form = $(this);

        let url = ghostpress_params.ajax_url + "&action=customer_registration",
            data = $form.serializeArray()

        gp_ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: data,
            show_loading: true
        })
            .done((response, textStatus, jqXHR) => {

                let success = response.success

                if(success){

                }else{
                    // Scroll to error notices
                    $("html").animate({
                        scrollTop: $(".notices").offset().top - 100
                    }, 1000);
                }

            })

    }

    let $form = $("form.registration_form");

    $form.on("submit", register);

})(jQuery);